import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from 'contexts/auth'

const UnauthenticatedRoute = ({ component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    <AuthConsumer>
      {({ isAuthenticated}) => (
        <Route 
          render={
            props =>
              !isAuthenticated
              ? <Component {...props} />
              : <Redirect to='/' />
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  )} />
)

export default UnauthenticatedRoute